import api from '@/api';
import { AxiosResponse } from 'axios';
import {
  fullReportResponseOptions,
  parseReportResponse,
} from '@/utils/functions/reportResponse';
import { API_BASE_URL } from '..';
import {
  DesignatedNotesRequest,
  InutilizationNumberRequest,
  InvoiceAllPDfRequest,
  InvoiceAllXmlRequest,
  ManifestNotesRequest,
} from './AuxiliaryDocuments.types';

const CONTROLLER_URL = `${API_BASE_URL}/auxiliary-documents/invoices`;

export async function allXml(obj: InvoiceAllXmlRequest) {
  const result = (await api.getReport(
    `${API_BASE_URL}/auxiliary-documents/all-xml`,
    obj,
  )) as unknown;

  return result as Blob;
}

export async function transmissionCorrection(cceId: number) {
  const result = (await api.post(
    `${CONTROLLER_URL}/cce/${cceId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function generatePdfCorrection(cceId: number) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/cce/${cceId}/generate-pdf`,
  )) as unknown;
  return result as Blob;
}

export async function designatedNotes(obj: DesignatedNotesRequest) {
  const result = (await api.post(
    `${CONTROLLER_URL}/manifestacao-destinatario/designated-notes`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function manifestNotes(obj: ManifestNotesRequest) {
  const result = (await api.post(
    `${CONTROLLER_URL}/manifestacao-destinatario/manifest`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function numberInutilization(obj: InutilizationNumberRequest) {
  const result = (await api.post(
    `${API_BASE_URL}/auxiliary-documents/number-inutilization`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function numberInutilizationXml(id: number) {
  const result = (await api.getReport(
    `${API_BASE_URL}/auxiliary-documents/number-inutilization/xml/${id}`,
    null,
  )) as unknown;

  return result as Blob;
}

export async function auxiliaryDocumentsDownloadAllPDF(
  params: InvoiceAllPDfRequest,
): Promise<BlobPart> {
  const result = (await api.getReport(
    `${API_BASE_URL}/auxiliary-documents/all-pdf`,
    params,
    fullReportResponseOptions,
  )) as unknown;

  return parseReportResponse(result as AxiosResponse<ArrayBufferLike>);
}
